import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosPrivate from '../../../config/axiosPrivate';

export const fetchConsultantOrderList = createAsyncThunk(
  'consultantOrderList/fetchConsultantOrderList',
  async (arg, thunkAPI) => {
    try {
      const response = await axiosPrivate.get('/user/myCommands');
      if (response.status === 200) {
        return response.data;
      }
      return thunkAPI.rejectWithValue(response.status);
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
